import { Outlet, ScrollRestoration } from 'react-router-dom';
import { AppFooter } from '../components/AppFooter';
import { AppHeader } from '../components/AppHeader';
import { PwaPrompts } from '../features/pwa/PwaPrompts';
import { DocumentTitle } from './DocumentTitle';

export function AppLayout() {
  return (
    <div className="app-shell">
      <DocumentTitle />
      <AppHeader />
      <main className="app-main" id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <AppFooter />
      <PwaPrompts />
      <ScrollRestoration />
    </div>
  );
}
